import type { Fish } from './fish';

export const ABSORB_GAIN = 0.3;

export function applyGrowth(fish: Fish, dt: number): boolean {
    if (dt <= 0) return false;
    fish.age += dt;
    if (fish.growthRate <= 0 || fish.mass >= fish.massCap) return false;
    const next = Math.min(fish.mass + fish.growthRate * dt, fish.massCap);
    if (next === fish.mass) return false;
    fish.setMass(next);
    return true;
}

export function tryAbsorb(big: Fish, small: Fish, ratio: number): boolean {
    if (big === small) return false;
    if (small.mass <= 0) return false;
    if (big.mass / small.mass <= ratio) return false;
    const dist = big.location.dist(small.location);
    const range = (big.length + small.length) / 2;
    if (dist > range) return false;
    big.setMass(big.mass + small.mass * ABSORB_GAIN);
    return true;
}

export interface LifecycleResult {
    grown: number;
    absorbed: number;
}

export function runLifecycle(creatures: Fish[], dt: number, ratio: number): LifecycleResult {
    let grown = 0;
    for (const f of creatures) {
        if (applyGrowth(f, dt)) grown++;
    }

    let absorbed = 0;
    for (let i = creatures.length - 1; i >= 0; i--) {
        const small = creatures[i];
        if (small === undefined) continue;
        let eaten = false;
        for (const big of creatures) {
            if (tryAbsorb(big, small, ratio)) {
                eaten = true;
                break;
            }
        }
        if (eaten) {
            creatures.splice(i, 1);
            absorbed++;
        }
    }
    return { grown, absorbed };
}
